/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const NestedDefaultVersion = zod.strictObject({
    id: zod.number(),
    data_source: zod.strictObject({
        id: zod.number(),
        url: zod.string().nullable(),
    }),
});

export type NestedDefaultVersion = zod.input<typeof NestedDefaultVersion>;
export type NestedDefaultVersionOutput = zod.output<
    typeof NestedDefaultVersion
>;
